import { render, staticRenderFns } from "./NaoEncontrado.vue?vue&type=template&id=0948df3a&"
import script from "./NaoEncontrado.vue?vue&type=script&lang=js&"
export * from "./NaoEncontrado.vue?vue&type=script&lang=js&"
import style0 from "./NaoEncontrado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports